import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { Counter } from "./Counter";
import { HARYANA_STATS } from "../../config/site";

export const Vision = () => (
  <Section
    id="vision"
    dark
    overline="The moment"
    title="India is building. Haryana is leading."
    sub="Make in India, Aatmanirbhar Bharat and Viksit Bharat 2047 have turned manufacturing into a national mission. Haryana's Viksit Haryana push is taking industry beyond NCR — and Bhiwani sits on that corridor."
  >
    <div className="grid grid-cols-2 gap-px overflow-hidden border border-paper/15 bg-paper/15 lg:grid-cols-4">
      {HARYANA_STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08}>
          <div className="h-full bg-forest p-6 sm:p-8" data-testid={`vision-stat-${i}`}>
            <p className="font-display text-4xl sm:text-5xl font-medium text-gold">
              <Counter
                value={s.value}
                decimals={s.decimals || 0}
                prefix={s.prefix || ""}
                suffix={s.suffix || ""}
              />
            </p>
            <p className="mt-3 text-sm font-medium text-paper">{s.label}</p>
            <p className="mt-1 text-xs text-paper/55">{s.note}</p>
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.2}>
      <p className="mt-8 text-xs text-paper/45">
        Sources: Haryana state budget & economic survey 2025-26. Figures as published.
      </p>
    </Reveal>
  </Section>
);
